import { createInfrastructureMarkerIcon } from './leafletSvgMarkerFactory';

export const createOLTMarker = (status = 'offline', options = {}) => createInfrastructureMarkerIcon({
  type: 'olt',
  status,
  focused: !!options?.focused,
  rootCause: !!options?.rootCause,
});

export const createODPMarker = (status = 'offline', options = {}) => createInfrastructureMarkerIcon({
  type: 'odp',
  status,
  focused: !!options?.focused,
  rootCause: !!options?.rootCause,
});

export const drawConnection = (fromPoint, toPoint, options = {}) => {
  const { error = false, weight = 3.2 } = options;
  const className = error ? 'connection-flow-error' : 'connection-flow-normal';
  return {
    className,
    positions: [fromPoint, toPoint],
    pathOptions: {
      color: error ? '#ff4b5c' : '#00e5ff',
      weight,
      opacity: 0.98,
      lineCap: 'round',
      dashArray: '10 8',
      className,
    },
  };
};
